import React from 'react';
import styled from 'styled-components';
import HeroSection from './HeroSection';
import ContentsSection from './ContentsSection';
import ExperienceSection from './ExperienceSection';
import MarketingSolutionSection from './MarketingSolutionSection';
import CampaignSection from './CampaignSection';
import PartnersSection from './PartnersSection';
import CtaSection from './CtaSection';

const HomeSectionWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

const HomeSection: React.FC = () => {
  return (
    <HomeSectionWrapper>
      <HeroSection />
      <ContentsSection />
      <ExperienceSection />
      <MarketingSolutionSection />
      <CampaignSection />
      <PartnersSection />
      <CtaSection />
    </HomeSectionWrapper>
  );
};

export default HomeSection;
